import React from 'react'
import { connect } from 'react-redux'
import Reconciliations from '../components/reconciliations'

const mapStateToProps = (state) => ({
  ...state.reconciliations
})

const mapDispatchToProps = dispatch => ({
  setPage: payload => dispatch({type: 'RECONCILIATIONS.SETPAGE', payload}),
  setPerPage: payload => dispatch({type: 'RECONCILIATIONS.PAGESIZE', payload}),
  onOrder: payload => dispatch({type: 'RECONCILIATIONS.ORDER', payload}),
  onCloseGame: payload => dispatch({type: 'RECONCILIATIONS.CLOSE_GAME', payload}),
  onUpdateGame: payload => dispatch({type: 'RECONCILIATIONS.UPDATE_GAME', payload}),
  onApplyFilters: payload => dispatch({type: 'RECONCILIATIONS.APPLY_FILTERS', payload}),
  onRefreshGame: payload => dispatch({type: 'OPEN_GAME_MODAL.REFRESH_GAME', payload}),
  onUpdateFacilityPay: payload => dispatch({type: 'RECONCILIATIONS.UPDATE_FACILITY_PAY', payload}),
  onLocationUpdate: payload => dispatch({type: 'RECONCILIATIONS.UPDATE_LOCATION', payload})
})

export default connect(mapStateToProps, mapDispatchToProps)(Reconciliations)
